import {
    VIEW_EXAM_TYPE_SUCCESS,
    VIEW_EXAM_TYPE_FAILED
} from './actionTypes'

const INIT_STATE = {
    error: "",
    loading: false,
    exam_type: null
}

const LessonScoreReducer = (state = INIT_STATE, action) => {

    switch (action.type) {
      
      case VIEW_EXAM_TYPE_SUCCESS: {
        return {
          ...state,
          loading: false,
          exam_type: action.payload,
          error: "",
        }
      }
      case VIEW_EXAM_TYPE_FAILED: {
        return {
          ...state,
          loading: false,
          exam_type: null,
          error: action.payload,
        }
      }
      default:
        return state
    }

}

export default LessonScoreReducer;